import ArtifactGroupType from "../base/ArtifactGroupType";

const BustOfMarcusAurelius = {
  id: '102',
  name: 'Bust Of Marcus Aurelius',
  icon: 'BustOfMarcusAurelius',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 25
};

export default BustOfMarcusAurelius;
